// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'

import {
  filterAndSortPaths,
  updateBulkEditState,
} from 'redux/modules/bulkEdit'

const assignBulkSort = newCol => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { bulkEdit } = getState()
      const oldAsc = bulkEdit.get('sortAsc')
      const oldCol = bulkEdit.get('sortCol')

      // if we're sorting by a new column, make it ascending,
      // otherwise toggle asc
      const sortAsc = oldCol !== newCol ? true : !oldAsc
      const sortCol = newCol

      const newState = {
        sortAsc,
        sortCol,
      }

      await dispatch(updateBulkEditState(newState))
      dispatch(filterAndSortPaths())
    })
  )
)
export default assignBulkSort
